module.exports = __webpack_public_path__ + "img/reset-deactive.ca335d20.svg";